import React from 'react';
import { iconFor } from '../../utils/gamification';
import './MedalArt.css';

/**
 * A medalha grande do modal e da página pública. Conquistada: raios girando, brilho, faíscas e "pop".
 * Não conquistada: cinza com o anel de progresso. Respeita prefers-reduced-motion (no CSS).
 */
export function MedalArt({ icon, unlocked, pct = 0, size = 148, animate = true }) {
  const Icon = iconFor(icon);
  return (
    <div className={`mart ${unlocked ? 'is-won' : 'is-locked'} ${animate ? 'is-anim' : ''}`} style={{ '--mart-size': `${size}px` }}>
      {unlocked && <span className="mart__rays" aria-hidden="true" />}
      {unlocked && <span className="mart__glow" aria-hidden="true" />}
      {unlocked && animate && (
        <span className="mart__sparks" aria-hidden="true">
          {Array.from({ length: 14 }).map((_, i) => <i key={i} style={{ '--a': `${(360 / 14) * i}deg`, '--d': `${70 + (i % 3) * 22}px` }} />)}
        </span>
      )}
      {!unlocked && (
        <span className="mart__ring" aria-hidden="true" style={{ background: `conic-gradient(var(--lime) ${pct * 3.6}deg, rgba(255,255,255,0.12) 0)` }} />
      )}
      <span className="mart__medal">
        <Icon size={Math.round(size * 0.32)} strokeWidth={2.2} aria-hidden="true" />
        {unlocked && <span className="mart__shine" aria-hidden="true" />}
      </span>
    </div>
  );
}
